export const USE_EMULATORS = process.env.REACT_APP_USE_EMULATORS || false;

export const FUNCTIONS = {
    getInstanceData: 'https://getinstancedata-jz3mroynqa-ew.a.run.app',
};

if (USE_EMULATORS) {
    FUNCTIONS.getInstanceData = 'http://127.0.0.1:5001/wix-customer-feedback/europe-west1/getInstanceData';
}

